import React from "react";
import { STATUS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className }) => {
  const cfg = STATUS[status];
  if (!cfg) return null;
  const { Icon, label, className: cls } = cfg;
  return (
    <span
      data-testid={`badge-${label.toLowerCase().replace(/\s+/g, "-").replace(/ä/g, "a").replace(/ö/g, "o")}`}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        cls,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
};
